<p-floatLabel>
  <p-multiselect 
    id="externalSystemMultiselector"
    name="externalSystemMultiselector"
    [options]="externalSystems"
    [(ngModel)]="selectedExternalSystems"
    optionLabel="name"
    [maxSelectedLabels]="3"
    [selectedItemsLabel]="l('::ItemsSelected', selectedExternalSystems?.length)"
    [showClear]="true"
    [filter]="true"
    fluid
    [disabled]="isDisabled"
    (onChange)="onSelected()">
  </p-multiselect>
  <label for="externalSystemMultiselector">
    <app-label-content [isRequired]="isRequired">
      {{ l('::ExternalSystems') }}
    </app-label-content>
  </label>
</p-floatLabel>